import Vue from 'vue'

import '@mdi/font/css/materialdesignicons.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

export default new Vuetify({
	icons: {
		iconfont: 'mdi', // default - only for display purposes
	},
	theme: {
		dark: false,
		themes: {
			light: {
				primary: '#81a3a7',
				secondary: '#c2d3da',
				accent: '#282726',
				error: '#c1403d',
				warning: '#d9ac2a',
				info: '#64B5F6',
				success: '#93a806'
			},
			dark: {
				primary: '#fff',
				secondary: '#c2d3da',
				accent: '#282726',
				error: '#c1403d',
				warning: '#d9ac2a',
				info: '#64B5F6',
				success: '#93a806'
			},
		},
	}
})